import React from "react";
import "./WebDev.css";

export const WebDev = () => {
  return (
    <main className="bodyContent webDevPage">
      <section className="webDevContent">
        <h1>Web Design &amp; Development</h1>

        <p>
          We build modern, scalable, and high-performance websites tailored to
          your business needs. From corporate websites to custom web
          applications, we focus on user experience, performance, and long-term
          maintainability.
        </p>

        <p>
          Our solutions are designed not just to look good, but to drive
          engagement, improve conversion, and support your business growth.
        </p>

        <h2>Key Features</h2>

        <ul>
          <li>Responsive Design (Mobile &amp; Desktop)</li>
          <li>SEO-friendly Architecture</li>
          <li>High Performance &amp; Security</li>
          <li>Custom Backend &amp; API Integration</li>
          <li>Scalable System Design</li>
        </ul>
      </section>
    </main>
  );
};
